import React from 'react'
import { CircularProgressbar , buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export default function Archive() {
  return (
    <div className='ArchiveContainer'>
      <div className='HomeDataContainer'>
        <div className='HomeTrackerArea'>
        <div className='TrackerHeader'>Toplam şut</div>
        <div style={{ width: 75, height: 75 , marginTop:10}}>
          <CircularProgressbar
            value={22}
            text={`${12}`}
            strokeWidth={15}
            styles={buildStyles({
            strokeLinecap: 'butt',
            pathTransitionDuration: 3,
            trailColor: 'red',
             })}
            />
           </div>
        </div>
        <div className='HomeTrackerArea'>
        <div className='TrackerHeader'>Kurtarılan şut</div>
        <div style={{ width: 75, height: 77 , marginTop:10}}>
          <CircularProgressbar
            value={50}
            text={`${50}`}
            strokeWidth={15}
            styles={buildStyles({
            strokeLinecap: 'butt',
            pathTransitionDuration: 3,
            trailColor: 'red',
             })}
            />
           </div>
        </div>
        <div className='HomeTrackerArea'>
        <div className='TrackerHeader'>Posizyon</div>
        <div style={{ width: 75, height: 75 , marginTop:10}}>
          <CircularProgressbar
            value={90}
            text={`${90}`}
            strokeWidth={15}
            styles={buildStyles({
            strokeLinecap: 'butt',
            pathTransitionDuration: 3,
            trailColor: 'red',
             })}
            />
           </div>
        </div>
      </div>
      <div className='TrackerScoreCon'>
      <div className='Teamssss'>
        <div className='TrackerTimeArea'>
          <div>61.00</div>
        </div>
        <div className='TrackerTeamArea'>
        <div className='TeamssImageText'><img src='/flags/3051.png' width={28} height={28}></img><div>Trabzonspor</div></div>
         <div>2-0</div>
         <div className='TeamssImageText'><img src='/flags/3052.png' width={28} height={28}></img><div>Fenerbahçe</div></div>
        </div>
      </div>
      <div className='TrackerPitch'>
          <div className='TrackerPitchArea'>
            <div id='TrackerBall'></div>
          </div>
      </div>
      <div className='TrackerButtonArea'>
        <div>Puan Durumu</div>
        <div>Canlı Puan Durumu</div>
        <div>Kadro</div>
        <div>İstatistik</div>
      </div>
      </div>
      <div className='AwayDataContainer'>
      <div className='HomeTrackerArea'>
        <div className='TrackerHeader'>Toplam şut</div>
        <div style={{ width: 75, height: 75 , marginTop:10}}>
          <CircularProgressbar
            value={22}
            text={`${12}`}
            strokeWidth={15}
            styles={buildStyles({
            strokeLinecap: 'butt',
            pathTransitionDuration: 3,
            trailColor: 'red',
             })}
            />
           </div>
        </div>
        <div className='HomeTrackerArea'>
        <div className='TrackerHeader'>Kurtarılan şut</div>
        <div style={{ width: 75, height: 75 , marginTop:10}}>
          <CircularProgressbar
            value={50}
            text={`${50}`}
            strokeWidth={15}
            styles={buildStyles({
            strokeLinecap: 'butt',
            pathTransitionDuration: 3,
            trailColor: 'red',
             })}
            />
           </div>
        </div>
        <div className='HomeTrackerArea'>
        <div className='TrackerHeader'>Posizyon</div>
        <div style={{ width: 75, height: 75 , marginTop:10}}>
          <CircularProgressbar
            value={90}
            text={`${90}`}
            strokeWidth={15}
            styles={buildStyles({
            strokeLinecap: 'butt',
            pathTransitionDuration: 3,
            trailColor: 'red',
             })}
            />
           </div>
        </div>
      </div>
    </div>
  )
}




